import React, { useEffect, useRef, useState } from "react";
import WebFont from "webfontloader";
import VoiceRecorder from "./VoiceRecorder";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { v4 as uuidv4 } from "uuid";
import io from "socket.io-client";

// WebSocket connection for chatbot namespace
let socket = null;

const VideoPlayer1 = ({ keyProp, video }) => {
  useEffect(() => {
    console.log(video);
  }, [video]);
  return (
    <div
      className="videoplayer"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "34%, !important",
      }}
    >
      <video
        key={keyProp}
        width=""
        style={{ borderRadius: "50%", height: "34%, !important" }}
        autoPlay
      >
        <source src={video} />
        Your browser does not support HTML video.
      </video>
    </div>
  );
};

const VideoPlayer = React.memo(({ keyProp, video }) => {
  const videoRef = useRef(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.src = video;
    }
  }, [video]);
  const handleVideoLoad = () => {
    console.log("handleVideoLoad");
    setLoading(false);
  };

  const handleVideoError = () => {
    console.log("asdaghsdvhmn");
  };
  const abcd = () => {
    setLoading(true);
  };

  return (
    <div
      className="videoplayer"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {loading && (
        <img
          style={{
            borderRadius: "100%",
            height: "180px",
            width: "180px",
            objectFit: "cover",
          }}
          src="https://sitemployee.sourcesoftsolutions.com//assets/images/chatbot/chatgirl.jpg"
        />
      )}

      <video
        onError={handleVideoError}
        onLoadedData={handleVideoLoad}
        onLoadStart={abcd}
        ref={videoRef}
        width=""
        style={{
          borderRadius: "100%",
          height: "180px",
          width: "180px",
          objectFit: "cover",
          display: loading ? "none" : "block",
        }}
        autoPlay
      >
        <source src={video} />
        Your browser does not support HTML video.
      </video>
    </div>
  );
});

const Chatbotcontent = ({
  hideChatbot,
  settings,
  platformId,
  user_id,
  chatbot_id,
}) => {
  // console.log("settings", settings);
  const [query, setquery] = useState("");
  const [currentQuestion, setCurrentQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [source, setSource] = useState("");
  const [loader, setLoader] = useState(false);
  const [selectedFont, setSelectedFont] = useState(
    // settings?.font ||
    "Poppins",
  );
  const [audioBlob, setAudioBlob] = useState(null);
  const [isRecording, setIsRecording] = useState(false);
  const [chatSessionId, setChatSessionId] = useState("");
  const [talkToAgent, setTalkToAgent] = useState(false);
  const [currentTicketId, setCurrentTicketId] = useState(null);
  const [isAdminTyping, setIsAdminTyping] = useState(false);

  const [audioUrl, setAudioUrl] = useState("");
  const [video, setVideo] = useState("");
  const [key, setKey] = useState(0);
  const messagesEndRef = useRef(null);
  const scrollContainerRef = useRef(null);
  const typingTimeoutRef = useRef(null);
  const sessionExpiryTime = 300000; // 5 minutes in milliseconds
  const sessionExpiryWarningTime = 270000; // 4 minutes 30 seconds in milliseconds
  let i = 0;
  const [lastActivityTime, setLastActivityTime] = useState(Date.now());

  const backgroundColor = settings?.chat_widget_color || "rgb(67, 183, 93)";
  const color = settings?.chat_widget_color || "rgb(67, 183, 93)";
  const borderColor = settings?.chat_widget_color || "rgb(67, 183, 93)";
  const boticon = settings?.avatar?.image_path
    ? `${process.env.REACT_APP_API_BACKEND_URL}/${settings.avatar.image_path}`
    : "https://sitemployee.sourcesoftsolutions.com/assets/images/chatbot/chat_icon.jpeg";

  // const platformId = document.getElementById('chat-bot').getAttribute('platform_id');

  const [chatContainer, setChatContainer] = useState([]);

  // Initialize WebSocket connection
  useEffect(() => {
    // Remove old ai_session_id if it exists (cleanup for old implementation)
    sessionStorage.removeItem("ai_session_id");

    // Check if session ID exists in sessionStorage
    let storedSessionId = sessionStorage.getItem("chatSessionId");
    let chatConnection = sessionStorage.getItem("chatConnection");
    let storedTicketId = sessionStorage.getItem("currentTicketId");

    console.log("chatConnection---", chatConnection);

    if (chatConnection == "false" || chatConnection == null) {
      setTalkToAgent((prev) => false);
    } else {
      setTalkToAgent((prev) => true);
    }

    if (storedTicketId) {
      setCurrentTicketId(parseInt(storedTicketId));
    }

    console.log("storedSessionId", storedSessionId);
    if (storedSessionId) {
      setChatSessionId((prev) => storedSessionId);
    } else {
      storedSessionId = uuidv4();
      sessionStorage.setItem("chatSessionId", storedSessionId);
      setChatSessionId((prev) => storedSessionId);
    }

    // Initialize socket connection with /chatbot namespace
    if (!socket) {
      const socketUrl = `${process.env.REACT_APP_BOT_BACKEND_URL}/chatbot`;
      socket = io(socketUrl, {
        transports: ["polling"],
        reconnection: false,
        timeout: 5000,
      });

      socket.on("connected", (data) => {
        console.log("🟢 Server ACK:", data.message);
      });

      socket.on("connect", () => {
        console.log(
          "✅ WebSocket connected to:",
          socketUrl,
          "| Socket ID:",
          socket.id,
        );

        // Join session
        socket.emit("join_session", {
          session_id: storedSessionId,
          agent_id: chatbot_id,
        });
      });

      socket.on("disconnect", () => {
        console.log("Disconnected from chatbot server");
      });

      socket.on("session_joined", (data) => {
        console.log("Session joined:", data);
      });

      // Listen for messages from admin
      socket.on("new_message", (data) => {
        console.log("New message from admin:", data);
        setChatContainer((prevContainer) => [
          ...prevContainer,
          {
            query: "",
            answer: data.text || data.message,
            qtype: "text",
            atype: "text",
            loading: false,
            queryTo: "agent",
            chat_type: "human",
          },
        ]);
      });

      // Message received confirmation
      socket.on("message_received", (data) => {
        console.log("Message received:", data);
        console.log("Sender type:", data.sender_type);

        // Only add messages from admin/agent, ignore user's own messages
        // Check sender_type to avoid echoing user's own messages
        if (data.sender_type === "admin" || data.sender_type === "agent") {
          const messageText = data.text || data.message;

          setChatContainer((prevContainer) => {
            // Check if this exact message already exists to avoid duplicates
            const messageExists = prevContainer.some(
              (chat) =>
                chat.answer === messageText &&
                chat.chat_type === "human" &&
                chat.queryTo === "agent",
            );

            if (!messageExists) {
              console.log("Adding admin message to chat:", messageText);
              return [
                ...prevContainer,
                {
                  query: "",
                  answer: messageText,
                  qtype: "text",
                  atype: "text",
                  loading: false,
                  queryTo: "agent",
                  chat_type: "human",
                },
              ];
            }

            return prevContainer;
          });
        } else {
          console.log("Ignoring user's own message echo");
        }
      });

      // Admin typing indicator
      socket.on("admin_typing", (data) => {
        console.log("Admin typing:", data);
        setIsAdminTyping(data.is_typing);
      });

      // Conversation reverted to human agent
      socket.on("conversation_reverted", (data) => {
        console.log("Conversation reverted to human agent:", data);

        // Update state to human agent mode
        setTalkToAgent(true);
        sessionStorage.setItem("chatConnection", true);

        // Update ticket ID if provided
        if (data.ticket_id) {
          setCurrentTicketId(data.ticket_id);
          sessionStorage.setItem("currentTicketId", data.ticket_id);
        }

        // Add message to chat container
        setChatContainer((prevContainer) => [
          ...prevContainer,
          {
            query: "",
            answer:
              data.message ||
              "Conversation has been transferred to a human agent",
            qtype: "text",
            atype: "text",
            loading: false,
            queryTo: "agent",
            chat_type: "human",
          },
        ]);
      });

      socket.on("error", (data) => {
        console.error("Socket error:", data);
      });
    }

    // Cleanup function
    return () => {
      if (socket) {
        socket.off("connect");
        socket.off("disconnect");
        socket.off("session_joined");
        socket.off("new_message");
        socket.off("message_received");
        socket.off("admin_typing");
        socket.off("conversation_reverted");
        socket.off("error");
      }
    };
  }, []);

  // Update last activity time whenever there is user interaction
  const handleUserInteraction = () => {
    // console.log("hi");
    setLastActivityTime(Date.now());
    console.log("lastActivityTime-", lastActivityTime);
  };

  // Check session expiry periodically
  useEffect(() => {
    if (talkToAgent) {
      const intervalId = setInterval(() => {
        const currentTime = Date.now();
        const timeElapsed = currentTime - lastActivityTime;
        console.log("timeElapsed", timeElapsed);
        if (timeElapsed >= sessionExpiryWarningTime) {
          i++;
          if (i === 1) {
            console.log("timeElapsed2", timeElapsed);
            setChatContainer((chatContainer) => [
              ...chatContainer,
              {
                query: "",
                answer: "Your session is about to closed",
                qtype: "text",
                atype: "text",
                loading: false,
                queryTo: "agent",
              },
            ]);
          }
        }
        if (timeElapsed >= sessionExpiryTime) {
          // Session expired, perform session cleanup or any other necessary actions
          resetSession();
          clearInterval(intervalId);
          closeChatbot();
          sessionStorage.removeItem("chatSessionId");
          setChatSessionId("");
          i = 0;
          console.log("session timeout");
        }
      }, 5000); // Check every minute
      return () => clearInterval(intervalId);
    }
  }, [lastActivityTime, talkToAgent]);

  const resetSession = () => {
    setLastActivityTime(Date.now());
    i = 0;
    // Perform any other necessary cleanup
  };

  const closeChatbot = () => {
    sessionStorage.removeItem("chatSessionId");
    sessionStorage.removeItem("currentTicketId");
    sessionStorage.setItem("chatConnection", false);
    setChatSessionId("");
    setTalkToAgent((prev) => false);
    setCurrentTicketId(null);

    // Disconnect socket
    if (socket && socket.connected) {
      socket.disconnect();
    }
  };

  useEffect(() => {
    if (chatSessionId) {
      getChatBotMessages();
    }
  }, [chatSessionId]);

  useEffect(() => {
    loadFonts();
  }, [selectedFont]);

  useEffect(() => {
    scrollToBottom();
  }, [chatContainer]);

  const loadFonts = () => {
    switch (selectedFont) {
      case "Ubuntu":
        WebFont.load({
          google: {
            families: ["Ubuntu:400,700"], // Load Ubuntu font with weights 400 and 700
          },
        });
        break;
      case "Google":
        WebFont.load({
          google: {
            families: ["Roboto:400,700"], // Load Roboto font with weights 400 and 700
          },
        });
        break;
      case "Poppins":
        WebFont.load({
          google: {
            families: ["Poppins:400,700"], // Load Poppins font with weights 400 and 700
          },
        });
        break;
      default:
        WebFont.load({
          google: {
            families: ["Poppins:400,700"], // Load Poppins font with weights 400 and 700
          },
        });
        break;
    }
  };

  const getChatBotMessages = async () => {
    const sessionId = chatSessionId || sessionStorage.getItem("chatSessionId");
    if (!sessionId) return;

    const chaturl = `https://crmprod-api.greymatterz.com/api/website-agents/${chatbot_id}/chat/${sessionId}`;
    console.log("📜 Fetching chat history:", chaturl);

    try {
      const response = await fetch(chaturl, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });

      const data = await response.json();
      console.log("chat history response--", data);

      const messages = data?.data?.messages;
      if (messages && messages.length > 0) {
        const mapped = messages.map((msg) => ({
          query: msg.sender_type === "user" ? msg.text : "",
          answer: msg.sender_type === "agent" ? msg.text : "",
          qtype: "text",
          atype: "text",
          loading: false,
          queryTo: msg.sender_type === "user" ? "user" : "agent",
          chat_type: msg.chat_type || "ai",
        }));
        setChatContainer(mapped);
      }
    } catch (error) {
      console.error("Failed to fetch chat history:", error);
    }
  };

  const handleinput = (e) => {
    setCurrentQuestion(e.target.value);
    setquery(e.target.value);

    // Send typing indicator only in human agent mode
    if (talkToAgent && socket && socket.connected) {
      socket.emit("typing", {
        session_id: chatSessionId,
        is_typing: true,
      });

      // Clear previous timeout
      if (typingTimeoutRef.current) {
        clearTimeout(typingTimeoutRef.current);
      }

      // Stop typing after 1 second of inactivity
      typingTimeoutRef.current = setTimeout(() => {
        socket.emit("typing", {
          session_id: chatSessionId,
          is_typing: false,
        });
      }, 1000);
    }
  };
  let abcd = query;

  function detectImages(text) {
    const imageRegex = /(https?:\/\/.*\.(?:png|jpg|jpeg|gif))/gi;
    const matches = text?.match(imageRegex);
    return matches ? matches : [];
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    // scrollToBottom();
    if (talkToAgent) {
      handleHumanSubmit(e);
      // handleAISubmit(e)
    } else {
      handleAISubmit(e);
      // handleHumanSubmit();
    }
  };

  const handleAISubmit = async (e) => {
    e.preventDefault();

    if (!query || query.trim() === "") return;

    // Use same chatSessionId for both AI and human agent
    const sessionId = chatSessionId || sessionStorage.getItem("chatSessionId");

    if (!sessionId) {
      console.error("No session ID available");
      return;
    }

    const payload = {
      message: query,
      chat_type: "ai", // ✅ default AI
      session_id: sessionId, // ✅ Use same session ID as human agent
      //ticket_id: 100000,
      sender_type: "user",
    };

    // Push user message to UI immediately
    setChatContainer((prev) => [
      ...prev,
      {
        query: query,
        answer: "...",
        qtype: "text",
        atype: "text",
        loading: true,
        chat_type: "ai",
      },
    ]);

    setLoader(true);
    setquery("");

    console.log("AI Chat - Session ID being used:", sessionId);
    console.log("AI Chat - Payload:", payload);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BACKEND_URL}/api/website-agents/${chatbot_id}/chat`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      const data = await response.json();

      setChatContainer((prev) => {
        const lastIndex = prev.length - 1;
        if (lastIndex < 0) return prev;

        return [
          ...prev.slice(0, lastIndex),
          {
            ...prev[lastIndex],
            answer: data?.data?.message || data?.data?.message || "No response",
            loading: false,
          },
        ];
      });
    } catch (error) {
      setChatContainer((prev) => {
        const lastIndex = prev.length - 1;
        if (lastIndex < 0) return prev;

        return [
          ...prev.slice(0, lastIndex),
          {
            ...prev[lastIndex],
            answer: "Sorry! Something went wrong",
            loading: false,
          },
        ];
      });
      console.error("AI chat error:", error);
    } finally {
      setLoader(false);
    }
  };

  const handleHumanSubmit = async (e) => {
    if (!query || !socket) return;

    // Use existing chatSessionId - don't generate new one
    const sessionId = chatSessionId || sessionStorage.getItem("chatSessionId");

    if (!sessionId) {
      console.error("No session ID available");
      return;
    }

    // Get ticket ID from state or session storage
    const ticketId =
      currentTicketId || sessionStorage.getItem("currentTicketId");

    // UI: show user message immediately
    setChatContainer((prev) => [
      ...prev,
      {
        query,
        answer: "",
        qtype: "text",
        atype: "text",
        loading: false,
        chat_type: "human",
        queryTo: "user",
      },
    ]);

    const messageToSend = query;
    setquery("");

    // Send message via WebSocket
    const payload = {
      message: messageToSend,
      session_id: sessionId,
      chat_type: "human",
      agent_id: chatbot_id,
    };

    // Add ticket_id only if it exists
    if (ticketId) {
      payload.ticket_id = parseInt(ticketId);
    }

    console.log("Sending message via WebSocket:", payload);
    console.log("Session ID being used:", sessionId);
    console.log("Ticket ID being sent:", ticketId);
    socket.emit("send_message", payload);
  };

  function clearAudio() {
    setAudioBlob("");
    setIsRecording(false);
  }

  const scrollToBottom = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = scrollContainerRef.current.scrollHeight;
    }
  };

  const connectToAgent = async (e) => {
    e.preventDefault();

    // Switch UI to human mode immediately
    setTalkToAgent(true);
    sessionStorage.setItem("chatConnection", true);
    setChatContainer((prev) => [
      ...prev,
      {
        query: "", answer: "Connecting you to a Human Agent, please wait…",
        qtype: "text", atype: "text", loading: false, queryTo: "agent", chat_type: "human",
      },
    ]);

    const postData = {
      chatbot_id: chatbot_id,
      session_id: chatSessionId,
      ticket_issue: "Talk to human agent",
    };

    console.log("Ticket Raise - Session ID being used:", chatSessionId);
    console.log("Ticket Raise - Payload:", postData);

    try {
      const url = `${process.env.REACT_APP_API_BACKEND_URL}/api/tickets/raise`;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(postData),
      });

      const data = await response.json();
      console.log("Ticket raised response:", data);

      if (data.status && data.data) {
        const ticketId = data.data.ticket_id;

        // ✅ Store ticket ID in state
        setCurrentTicketId(ticketId);

        // ✅ Store ticket ID in session storage
        sessionStorage.setItem("currentTicketId", ticketId);
        sessionStorage.setItem("chatConnection", true);

        setTalkToAgent((prev) => true);

        setChatContainer((chatContainer) => [
          ...chatContainer,
          {
            query: "",
            answer: `Hang tight, we are connecting you to a Human Agent `,
            qtype: "text",
            atype: "text",
            loading: false,
            queryTo: "agent",
            chat_type: "human",
          },
        ]);

        console.log("✅ Ticket ID stored:", ticketId);
        i = 0;
      } else {
        setChatContainer((chatContainer) => [
          ...chatContainer,
          {
            query: "",
            answer:
              "Sorry, unable to connect to human agent. Please try again.",
            qtype: "text",
            atype: "text",
            loading: false,
            queryTo: "agent",
          },
        ]);
      }
    } catch (error) {
      console.error("Error raising ticket:", error);
      setLoader(false);
    }
  };

  const connectToAI = async (e) => {
    e.preventDefault();

    setTalkToAgent((prev) => false);
    sessionStorage.setItem("chatConnection", false);
    sessionStorage.removeItem("currentTicketId");
    setCurrentTicketId(null);

    setChatContainer((chatContainer) => [
      ...chatContainer,
      {
        query: "",
        answer: "Switched back to AI Agent",
        qtype: "text",
        atype: "text",
        loading: false,
        queryTo: "agent",
        chat_type: "ai",
      },
    ]);

    i = 0;
  };

  const S = {
    avatar: {
      width: "34px", height: "34px", borderRadius: "50%", overflow: "hidden",
      flexShrink: 0, background: "#e8e8e8",
    },
    botBubble: {
      maxWidth: "72%", background: backgroundColor, color: "#fff",
      borderRadius: "4px 18px 18px 18px", padding: "11px 15px",
      fontSize: "13.5px", lineHeight: "1.6", wordBreak: "break-word",
      boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
    },
    userBubble: {
      maxWidth: "72%", background: "#fff", color: "#1a1a1a",
      borderRadius: "18px 4px 18px 18px", padding: "11px 15px",
      fontSize: "13.5px", lineHeight: "1.6", wordBreak: "break-word",
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    },
  };

  return (
    <div
      id="source-widget-container-right"
      className="source-tw-fixed source-tw-inset-0 md:source-tw-inset-auto"
      style={{ fontFamily: "'Poppins', sans-serif", width: "420px", textAlign: "left" }}
      onClick={handleUserInteraction}
    >
      <div style={{
        display: "flex", flexDirection: "column",
        width: "420px", height: "650px",
        background: "#f5f5f5",
        borderRadius: "20px",
        boxShadow: "0 12px 48px rgba(0,0,0,0.18)",
        overflow: "hidden",
      }}>

        {/* ── Header ── */}
        <div style={{
          background: backgroundColor,
          padding: "16px 16px 20px",
          flexShrink: 0,
        }}>
          {/* Top row: avatar + name + actions */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div style={{
                width: "48px", height: "48px", borderRadius: "50%", overflow: "hidden",
                flexShrink: 0, border: "2px solid rgba(255,255,255,0.6)", background: "#fff",
              }}>
                <img src={boticon} alt="Bot" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
              </div>
              <div style={{ textAlign: "left" }}>
                <div style={{ color: "rgba(255,255,255,0.82)", fontSize: "11px", fontWeight: "400", letterSpacing: "0.3px" }}>Chat with</div>
                <div style={{ color: "#fff", fontWeight: "700", fontSize: "17px", lineHeight: "1.2" }}>
                  {settings?.display_name || "AI Assistant"}
                </div>
              </div>
            </div>

            {/* Actions */}
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <button onClick={hideChatbot} title="Minimize" style={{
                background: "rgba(255,255,255,0.18)", border: "none", color: "#fff",
                width: "30px", height: "30px", borderRadius: "50%", cursor: "pointer",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: "20px", lineHeight: 1, paddingBottom: "2px",
              }}>−</button>
              <button onClick={() => { closeChatbot(); hideChatbot(); }} title="Close" style={{
                background: "rgba(255,255,255,0.18)", border: "none", color: "#fff",
                width: "30px", height: "30px", borderRadius: "50%", cursor: "pointer",
                display: "flex", alignItems: "center", justifyContent: "center",
              }}>
                <svg width="11" height="11" viewBox="0 0 352 512" fill="currentColor">
                  <path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"/>
                </svg>
              </button>
            </div>
          </div>

          {/* Bottom row: online status + toggle */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "12px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <span style={{ width: "7px", height: "7px", borderRadius: "50%", background: "#7dff9b", display: "inline-block", flexShrink: 0 }} />
              <span style={{ color: "rgba(255,255,255,0.9)", fontSize: "12px" }}>We're online</span>
            </div>

            {/* Agent toggle */}
            <div style={{
              display: "flex", background: "rgba(0,0,0,0.18)",
              borderRadius: "20px", padding: "3px", gap: "2px",
            }}>
              <button onClick={connectToAI} style={{
                fontSize: "11.5px", fontWeight: talkToAgent ? "400" : "600",
                padding: "4px 12px", borderRadius: "16px", border: "none",
                cursor: "pointer", whiteSpace: "nowrap",
                background: talkToAgent ? "transparent" : "#fff",
                color: talkToAgent ? "rgba(255,255,255,0.8)" : "#333",
                boxShadow: talkToAgent ? "none" : "0 1px 3px rgba(0,0,0,0.12)",
              }}>AI Agent</button>
              <button onClick={connectToAgent} style={{
                fontSize: "11.5px", fontWeight: talkToAgent ? "600" : "400",
                padding: "4px 12px", borderRadius: "16px", border: "none",
                cursor: "pointer", whiteSpace: "nowrap",
                background: talkToAgent ? "#fff" : "transparent",
                color: talkToAgent ? "#333" : "rgba(255,255,255,0.8)",
                boxShadow: talkToAgent ? "0 1px 3px rgba(0,0,0,0.12)" : "none",
              }}>Human</button>
            </div>
          </div>
        </div>

        {/* ── Messages ── */}
        <div style={{
          flex: 1, overflowY: "auto", padding: "16px 14px 8px",
          display: "flex", flexDirection: "column", gap: "12px",
          background: "#f5f5f5",
        }}>
          {/* Welcome */}
          <div style={{ display: "flex", alignItems: "flex-start", gap: "8px" }}>
            <div style={S.avatar}>
              <img src={boticon} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
            </div>
            <div style={S.botBubble}>
              {settings?.welcome_message?.greeting_text || "Welcome! How can I help you today?"}
            </div>
          </div>

          {chatContainer && chatContainer.map((chat, index) => (
            <div key={index} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              {/* User message — white card, right aligned */}
              {chat?.query && (
                <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end", gap: "8px" }}>
                  <div style={S.userBubble}>
                    {chat.qtype === "text" || !chat.qtype ? chat.query : (
                      <audio controls style={{ maxWidth: "180px" }}>
                        <source src={URL.createObjectURL(chat.query)} type="audio/wav" />
                      </audio>
                    )}
                  </div>
                </div>
              )}

              {/* Bot message — brand color, left aligned */}
              {(chat.chat_type === "ai" || !chat.chat_type) ? (
                loader && chat.loading ? (
                  <div style={{ display: "flex", alignItems: "flex-start", gap: "8px" }}>
                    <div style={S.avatar}>
                      <img src={boticon} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
                    </div>
                    <div style={{ ...S.botBubble, padding: "13px 18px" }}>
                      <div className="source-widget-dot-loader">
                        <div className="source-widget-dot" style={{ backgroundColor: "rgba(255,255,255,0.8)" }} />
                        <div className="source-widget-dot" style={{ backgroundColor: "rgba(255,255,255,0.8)" }} />
                        <div className="source-widget-dot" style={{ backgroundColor: "rgba(255,255,255,0.8)" }} />
                      </div>
                    </div>
                  </div>
                ) : chat.answer && chat.answer !== "..." ? (
                  <div style={{ display: "flex", alignItems: "flex-start", gap: "8px" }}>
                    <div style={S.avatar}>
                      <img src={boticon} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
                    </div>
                    <div style={S.botBubble}>
                      {!chat.atype || chat.atype === "text" ? (
                        <>
                          {chat.answer}
                          {detectImages(chat.answer).map((im, i) => (
                            <img key={i} src={im} alt="" style={{ maxWidth: "160px", marginTop: "6px", borderRadius: "8px", display: "block" }} />
                          ))}
                        </>
                      ) : (
                        <><span>{chat.answer}</span><audio controls style={{ marginTop: "6px" }}><source src={chat.answerAudio} type="audio/mp3" /></audio></>
                      )}
                    </div>
                    <div ref={messagesEndRef} />
                  </div>
                ) : null
              ) : chat.chat_type === "human" && chat.answer ? (
                <div style={{ display: "flex", alignItems: "flex-start", gap: "8px" }}>
                  <div style={S.avatar}>
                    <img src={boticon} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
                  </div>
                  <div style={S.botBubble}>
                    {!chat.atype || chat.atype === "text" ? (
                      <>
                        {chat.answer}
                        {detectImages(chat.answer).map((im, i) => (
                          <img key={i} src={im} alt="" style={{ maxWidth: "160px", marginTop: "6px", borderRadius: "8px", display: "block" }} />
                        ))}
                      </>
                    ) : (
                      <><span>{chat.answer}</span><audio controls style={{ marginTop: "6px" }}><source src={chat.answerAudio} type="audio/mp3" /></audio></>
                    )}
                  </div>
                  <div ref={messagesEndRef} />
                </div>
              ) : null}
            </div>
          ))}

          {talkToAgent && isAdminTyping && (
            <div style={{ display: "flex", alignItems: "flex-start", gap: "8px" }}>
              <div style={S.avatar}>
                <img src={boticon} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
              </div>
              <div style={{ ...S.botBubble, fontStyle: "italic", fontSize: "12px", opacity: 0.85 }}>
                Agent is typing…
              </div>
            </div>
          )}
          <div ref={messagesEndRef} />
        </div>

        {/* ── Input ── */}
        <div style={{
          background: "#fff", borderTop: "1px solid #e8e8e8",
          padding: "12px 14px 14px", flexShrink: 0,
        }}>
          <div style={{
            display: "flex", alignItems: "flex-end",
            background: "#f7f7f7", borderRadius: "14px",
            border: "1.5px solid #e4e4e4", padding: "10px 8px 8px 14px",
          }}>
            {!audioBlob ? (
              !isRecording ? (
                <textarea
                  style={{
                    flex: 1, border: "none", outline: "none", background: "transparent",
                    resize: "none", fontSize: "13.5px", lineHeight: "1.6", color: "#333",
                    padding: 0, maxHeight: "120px", overflowY: "auto", fontFamily: "inherit",
                  }}
                  rows={3}
                  placeholder="Ask me anything…"
                  maxLength="750"
                  value={query}
                  onChange={(e) => handleinput(e)}
                  onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); handleSubmit(e); } }}
                />
              ) : (
                <div style={{ flex: 1, display: "flex", alignItems: "center" }}>
                  <img src="https://sitemployee.sourcesoftsolutions.com/assets/images/chatbot/voiceloader.gif" alt="Recording" style={{ height: "28px" }} />
                </div>
              )
            ) : (
              <div style={{ flex: 1, display: "flex", alignItems: "center", gap: "6px" }}>
                <audio controls style={{ height: "30px", flex: 1 }}>
                  <source src={URL.createObjectURL(audioBlob)} type="audio/wav" />
                </audio>
                <button onClick={clearAudio} style={{ background: "none", border: "none", cursor: "pointer", color: "#aaa", padding: "2px", display: "flex" }}>
                  <IoIosCloseCircleOutline size={17} />
                </button>
              </div>
            )}

            <div style={{ display: "flex", alignItems: "center", gap: "4px", flexShrink: 0, paddingBottom: "2px" }}>
              <VoiceRecorder setAudioBlob={setAudioBlob} setIsRecording={setIsRecording} isRecording={isRecording} />
              {!isRecording && (
                <button
                  onClick={handleSubmit}
                  style={{
                    width: "36px", height: "36px", borderRadius: "50%",
                    background: backgroundColor, border: "none", cursor: "pointer",
                    display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                  }}
                >
                  <svg fill="#fff" viewBox="0 0 512 512" height="15" width="15">
                    <path d="M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"/>
                  </svg>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Chatbotcontent;
